import React from 'react'

const ThoughtBox = props =>
  <section className='thought box'>
    <a href={props.link} target='_blank'>
      <h4>{props.title}</h4>
      <div className='meta'>
        <p><i className='fa fa-calendar-o'></i> {props.month} {props.year}</p>
        <p><i className='fa fa-clock-o'></i> {props.minutes} min</p>
      </div>
    </a>
    <div className='text-container'>
      <p>{props.blurb}</p>
    </div>
    <a className='cta' href={props.link} target='_blank'><span className='hide-mobile-small'>See More on </span>{props.publicationName} <i className='fa fa-arrow-right'></i></a>
  </section>

export default ThoughtBox



// WEBPACK FOOTER //
// ./src/components/thought-box.js